
const textData = [
    {
        text: `
        Welcome to my portfolio, my name is João Pedro and I'm a bilingual QA test analyst looking for an opportunity to work as a Front End developer. This page was made from scratch in only 7 days.
        Born in Porto Alegre - RS, I am a college student with major in Information Systems. I also have a certification in Webdesign from Microcamp Tecnologia. I have a natural aptitude in learning and I have strong beliefs that I can learn any development tool at a decent level inside 15 days, as I did with React.js, Git and Typescript.
        `,
    },
    {
        text: `
        Bem vindo ao meu portifólio, meu nome é João Pedro e sou um analista de testes QA bilíngue procurando uma oportunidade para trabalhar como desenvolvedor Front End. Esta página foi criada do zero em apenas 7 dias.
        Natural de Porto Alegre - RS, sou aluno de graduação em Sistemas de Informação e possuo um curso em Webdesign pela Microcamp Tecnologia. Eu tenho aptidão nata em aprender e acredito fortemente que possa aprender qualquer ferramenta de desenvolvimento a nível decente em até 15 dias, como foi o caso com React.js, Git e Typescript.
        `,
    },
]

export default textData